export default "__VITE_ASSET__IbGOWkQh__";